import React from 'react';
import bodymovin from 'bodymovin/build/player/bodymovin_light.min';
import animationData from '../data/mundo.json';
import { circuitos } from '../data/circuitos';
import { colors } from '../utils/colors';

class Grafica extends React.Component {
	// State
	state = {
		anim: '',
		prev: false,
		next: true,
		frame: 0
	};

	animationIsAttached = false;

	//lifecycle
	componentDidMount() {
		this.attachAnimation();
	}

	componentWillReceiveProps() {}

	handleClickNext = () => {
		if (this.state.frame === 140) {
			this.setState({ next: false, frame: 160 });
			this.state.anim.playSegments(
				[this.state.frame, this.state.frame + 20],
				true
			);
		} else {
			this.state.anim.playSegments(
				[this.state.frame, this.state.frame + 20],
				true
			);
			this.setState({ frame: this.state.frame + 20, next: true, prev: true });
		}
	};

	handleClickPrev = () => {
		if (this.state.frame === 20) {
			this.setState({ prev: false, frame: 0 });
			this.state.anim.setDirection(-1);
			this.state.anim.playSegments(
				[this.state.frame, this.state.frame - 20],
				true
			);
		} else {
			this.state.anim.setDirection(-1);
			this.state.anim.playSegments(
				[this.state.frame, this.state.frame - 20],
				true
			);
			this.setState({ frame: this.state.frame - 20, prev: true, next: true });
		}
	};

	render() {
		let cambios = {
			width: 900,
			height: 800,
			zIndex: 2
		};
		const buttonContStyle = {
			width: '10%',
			display: 'flex',
			alignContent: 'center',
			justifyContent: 'center',
			alignItems: 'center'
		};
		const buttonStyle = {
			minWidth: '55px',
			height: '55px',
			cursor: 'pointer',
			display: 'flex',
			alignContent: 'center',
			justifyContent: 'center',
			alignItems: 'center',
			border: '1px solid black',
			background: 'white'
		};
		return (
			<div className="cambios">
				<div
					style={{
						maxWidth: '990px',
						margin: '0 auto',
						display: 'flex',
						alignContent: 'center',
						justifyContent: 'space-between',
						padding: '1em 0.9em 1em 0.9em'
					}}
				>
					<div style={buttonContStyle}>
						{this.state.prev && (
							<div style={buttonStyle} onClick={this.handleClickPrev}>
								<svg width="20" height="18" viewBox="0 0 16 14" fill="black">
									<path d="M3.4 8H16V6H3.3l5-4.7L7 0 0 7l7 7 1.3-1.3z" />
								</svg>
							</div>
						)}
					</div>
					<div className="cambio data">
						<h2
							style={{
								margin: 0,
								padding: 0,
								fontSize: '1.1em',
								fontWeight: 700
							}}
						>
							{circuitos[`c${this.state.frame}`].y}
						</h2>

						<p style={{ margin: 0, padding: 0 }}>
							<span>
								<strong>{circuitos[`c${this.state.frame}`].lng}</strong>
							</span>
						</p>
					</div>
					<div style={buttonContStyle}>
						{this.state.next && (
							<div
								style={buttonStyle}
								className={this.state.frame === 0 ? 'indicador' : ''}
								onClick={this.handleClickNext}
							>
								<svg
									className={this.state.frame === 0 ? 'pulseSvg' : ''}
									width="20"
									height="18"
									viewBox="0 0 16 14"
									fill={colors.black}
								>
									<path d="M12.6 6H0v2h12.7l-5 4.7L9 14l7-7-7-7-1.3 1.3z" />
								</svg>
							</div>
						)}
					</div>
				</div>
				{/* Div animado */}
				<div
					style={{
						position: 'relative',
						height: `${this.props.windowHeight / 2 - cambios.height / 2}px`,
						width: `${this.props.windowHeight / 2 - cambios.height / 2}px`,
						maxWidth: '990px',
						margin: '0 auto'
					}}
					ref={animationDiv => {
						this.animationContainer = animationDiv;
					}}
				>
					<div
						className="pulsar"
						style={{
							content: '',
							position: 'absolute',
							top: '32%',
							left: '43%',
							width: '20px',
							height: '20px'
						}}
					/>
				</div>
			</div>
		);
	}

	//animations
	attachAnimation = () => {
		if (this.animationContainer !== undefined && !this.animationIsAttached) {
			const animationProperties = {
				container: this.animationContainer,
				renderer: 'svg',
				loop: false,
				autoplay: false,
				animationData: animationData
			};

			let anim = bodymovin.loadAnimation(animationProperties);
			anim.setSpeed(1.2);
			this.setState({ anim: anim });
		}
	};
}

export default Grafica;



// WEBPACK FOOTER //
// ./src/components/Grafica.js